	document.addEventListener("DOMContentLoaded", async ()=> {

	const doppleVisual = document.querySelector('atlatl-visual')
	const doppleProduct = document.querySelector('av-product')
	  
	  await doppleVisual.ready()
		document.querySelector('.sticky_img').classList.add('dopple_loaded');
		if (window.innerWidth >= 900) {
		  doppleProduct.product.setValue('runRotation', true);
		}
		doppleProduct.product.setValue('4DArms', true);
		doppleProduct.product.setValue('base', 'fiveSpoke');

	  var qpConfig = window.location.href;
	  var configWithoutQueryString = qpConfig.split('?')[0];
	  var configPath = configWithoutQueryString.split('/');
	  var currentConfig = configPath[configPath.length - 1];

	  if (currentConfig === "onyx-standard-ivory") {
		doppleProduct.product.setValue('fabric', 'ivoryBoucle');
	  }
	  if (currentConfig === "onyx-standard-dune") {
		doppleProduct.product.setValue('fabric', 'duneBoucle');
	  }
	  if (currentConfig === "onyx-standard-steel") {
		doppleProduct.product.setValue('fabric', 'steelBoucle');
	  }
	  if (currentConfig === "onyx-standard-pink") {
		doppleProduct.product.setValue('fabric', 'pinkBoucle');
	  }
	  if (currentConfig === "onyx-carbon-fiber") {
		doppleProduct.product.setValue('backPanel', 'carbonFiber');
		doppleProduct.product.setValue('fabric', 'onyxLeather');
	  }
	  if (currentConfig === "onyx-carbon-ivory") {
		doppleProduct.product.setValue('backPanel', 'carbonFiber');
		doppleProduct.product.setValue('fabric', 'ivoryLeather');
	  }
	  if (currentConfig === "onyx-carbon-fiber-dune") {
		doppleProduct.product.setValue('backPanel', 'carbonFiber');
		doppleProduct.product.setValue('fabric', 'duneLeather');
	  }
	  if (currentConfig === "onyx-carbon-fiber-steel") {
		doppleProduct.product.setValue('backPanel', 'carbonFiber');
		doppleProduct.product.setValue('fabric', 'steelLeather');
	  }
	  if (currentConfig === "onyx-carbon-fiber-pink") {
		doppleProduct.product.setValue('backPanel', 'carbonFiber');
		doppleProduct.product.setValue('fabric', 'pinkBoucle');
	  }
      if (currentConfig === "anthros-chair-onyx-natural-oak-4-spoke") {
		doppleProduct.product.setValue('backPanel', 'naturalOak');
        doppleProduct.product.setValue('base', 'fourSpoke');
	  }
	  if (currentConfig === "quartz-natural-oak") {
		doppleProduct.product.setValue('chairColor', 'quartz');
		doppleProduct.product.setValue('backPanel', 'naturalOak');
		doppleProduct.product.setValue('fabric', 'ivoryBoucle');
	  }
	  if (currentConfig === "quartz-natural-oak-dune") {
		doppleProduct.product.setValue('chairColor', 'quartz');
		doppleProduct.product.setValue('backPanel', 'naturalOak');
		doppleProduct.product.setValue('fabric', 'duneBoucle');
	  }
	  if (currentConfig === "quartz-natural-oak-steel") {
		doppleProduct.product.setValue('chairColor', 'quartz');
		doppleProduct.product.setValue('backPanel', 'naturalOak');
		doppleProduct.product.setValue('fabric', 'steelBoucle');
	  }
	  if (currentConfig === "quartz-natural-oak-onyx") {
		doppleProduct.product.setValue('chairColor', 'quartz');
		doppleProduct.product.setValue('backPanel', 'naturalOak');
		doppleProduct.product.setValue('fabric', 'onyxBoucle');
	  }
	  if (currentConfig === "quartz-natural-oak-pink") {
		doppleProduct.product.setValue('chairColor', 'quartz');
		doppleProduct.product.setValue('backPanel', 'naturalOak');
		doppleProduct.product.setValue('fabric', 'pinkBoucle');
	  }
	  if (currentConfig === "quartz-walnut") {
		doppleProduct.product.setValue('chairColor', 'quartz');
		doppleProduct.product.setValue('backPanel', 'walnut');
		doppleProduct.product.setValue('fabric', 'ivoryLeather');
	  }
	  if (currentConfig === "quartz-walnut-dune") {
		doppleProduct.product.setValue('chairColor', 'quartz');
		doppleProduct.product.setValue('backPanel', 'walnut');
		doppleProduct.product.setValue('fabric', 'duneLeather');
	  }
	  if (currentConfig === "quartz-walnut-steel") {
		doppleProduct.product.setValue('chairColor', 'quartz');
		doppleProduct.product.setValue('backPanel', 'walnut');
		doppleProduct.product.setValue('fabric', 'steelLeather');
	  }
	  if (currentConfig === "quartz-walnut-onyx") {
		doppleProduct.product.setValue('chairColor', 'quartz');
		doppleProduct.product.setValue('backPanel', 'walnut');
		doppleProduct.product.setValue('fabric', 'onyxLeather');
		$('.select__select option').click(function(){    
		  doppleProduct.product.setValue('fabric', 'onyxBoucle');
		});
	  }
	  if (currentConfig === "onyx-circuit") {
		doppleProduct.product.setValue('backPanel', 'circuitOnyx');
	  }
	  if (currentConfig === "onyx-circuit-dune") {
		doppleProduct.product.setValue('backPanel', 'circuitOnyx');
		doppleProduct.product.setValue('fabric', 'duneBoucle');
	  }
	   if (currentConfig === "onyx-circuit-ivory") {
		doppleProduct.product.setValue('backPanel', 'circuitOnyx');
		doppleProduct.product.setValue('fabric', 'ivoryBoucle');
	  }
	   if (currentConfig === "onyx-circuit-pink") {
		doppleProduct.product.setValue('backPanel', 'circuitOnyx');
		doppleProduct.product.setValue('fabric', 'pinkBoucle');
	  } 
	  if (currentConfig === "onyx-circuit-steel") {
		doppleProduct.product.setValue('backPanel', 'circuitOnyx');
		doppleProduct.product.setValue('fabric', 'steelBoucle');
	  } 
	  
	  if (currentConfig === "onyx-grey-oak") {
		doppleProduct.product.setValue('backPanel', 'greyOakV2');
		doppleProduct.product.setValue('fabric', 'onyxBoucle');
	  } 
	  if (currentConfig === "onyx-grey-oak-dune") {
		doppleProduct.product.setValue('backPanel', 'greyOakV2');
		doppleProduct.product.setValue('fabric', 'duneBoucle');
	  }  
	  if (currentConfig === "onyx-grey-oak-ivory") {
		doppleProduct.product.setValue('backPanel', 'greyOakV2');
		doppleProduct.product.setValue('fabric', 'ivoryBoucle');
	  }   
	  if (currentConfig === "onyx-grey-oak-pink") {
		doppleProduct.product.setValue('backPanel', 'greyOakV2');
		doppleProduct.product.setValue('fabric', 'pinkBoucle');
	  }   
	  if (currentConfig === "onyx-grey-oak-steel") {
		doppleProduct.product.setValue('backPanel', 'greyOakV2');
		doppleProduct.product.setValue('fabric', 'steelBoucle');
	  }  
	  if (currentConfig === "onyx-sierra-oak") {
		doppleProduct.product.setValue('backPanel', 'sierraOak');
		doppleProduct.product.setValue('fabric', 'steelBoucle');
	  }  
	  if (currentConfig === "onyx-sierra-oak-dune") {
		doppleProduct.product.setValue('backPanel', 'sierraOak');
		doppleProduct.product.setValue('fabric', 'duneBoucle');
	  } 
	  if (currentConfig === "onyx-sierra-oak-ivory") {
		doppleProduct.product.setValue('backPanel', 'sierraOak');
		doppleProduct.product.setValue('fabric', 'ivoryBoucle');
	  }  
	  if (currentConfig === "onyx-sierra-oak-pink") {
		doppleProduct.product.setValue('backPanel', 'sierraOak');
		doppleProduct.product.setValue('fabric', 'pinkBoucle');
	  } 
	  if (currentConfig === "onyx-sierra-oak-steel") {
		doppleProduct.product.setValue('backPanel', 'sierraOak');
		doppleProduct.product.setValue('fabric', 'steelBoucle');
	  }  
	  if (currentConfig === "onyx-walnut-dune") {
		doppleProduct.product.setValue('backPanel', 'walnut');
		doppleProduct.product.setValue('fabric', 'duneBoucle');
	  }  
	  if (currentConfig === "onyx-walnut-ivory") {
		doppleProduct.product.setValue('backPanel', 'walnut');
		doppleProduct.product.setValue('fabric', 'ivoryBoucle');
	  } 
	  if (currentConfig === "onyx-walnut-steel") {
		doppleProduct.product.setValue('backPanel', 'walnut');
		doppleProduct.product.setValue('fabric', 'steelBoucle');
	  } 
	  if (currentConfig === "onyx-walnut-onyx") {
		doppleProduct.product.setValue('backPanel', 'walnut');
		doppleProduct.product.setValue('fabric', 'onyxBoucle');
	  } 
	  if (currentConfig === "quartz-circuit-dune") {
		doppleProduct.product.setValue('chairColor', 'quartz');
		doppleProduct.product.setValue('backPanel', 'circuitIvory');
		doppleProduct.product.setValue('fabric', 'duneBoucle');
	  }  
	  if (currentConfig === "quartz-circuit-ivory") {
		doppleProduct.product.setValue('chairColor', 'quartz');
		doppleProduct.product.setValue('backPanel', 'circuitIvory');
		doppleProduct.product.setValue('fabric', 'ivoryBoucle');
	  }
	  if (currentConfig === "quartz-circuit-onyx") {
		doppleProduct.product.setValue('chairColor', 'quartz');
		doppleProduct.product.setValue('backPanel', 'circuitIvory');
		doppleProduct.product.setValue('fabric', 'onyxBoucle');
	  } 
	  if (currentConfig === "quartz-circuit-pink") {
		doppleProduct.product.setValue('chairColor', 'quartz');
		doppleProduct.product.setValue('backPanel', 'circuitIvory');
		doppleProduct.product.setValue('fabric', 'pinkBoucle');
	  }  
	  if (currentConfig === "quartz-circuit-steel") {
		doppleProduct.product.setValue('chairColor', 'quartz');
		doppleProduct.product.setValue('backPanel', 'circuitIvory');
		doppleProduct.product.setValue('fabric', 'steelBoucle');
	  }  
	  if (currentConfig === "quartz-ivory-oak") {
		doppleProduct.product.setValue('chairColor', 'quartz');
		doppleProduct.product.setValue('backPanel', 'ivoryOakV2');
		doppleProduct.product.setValue('fabric', 'ivoryBoucle');
	  }  
	  if (currentConfig === "quartz-ivory-oak-dune") {
		doppleProduct.product.setValue('chairColor', 'quartz');
		doppleProduct.product.setValue('backPanel', 'ivoryOakV2');
		doppleProduct.product.setValue('fabric', 'duneBoucle');
	  }  
	  if (currentConfig === "quartz-ivory-oak-onyx") {
		doppleProduct.product.setValue('chairColor', 'quartz');
		doppleProduct.product.setValue('backPanel', 'ivoryOakV2');
		doppleProduct.product.setValue('fabric', 'onyxBoucle');
	  }   
	  if (currentConfig === "quartz-ivory-oak-pink") {
		doppleProduct.product.setValue('chairColor', 'quartz');
		doppleProduct.product.setValue('backPanel', 'ivoryOakV2');
		doppleProduct.product.setValue('fabric', 'pinkBoucle');
	  }  
	  if (currentConfig === "quartz-ivory-oak-steel") {
		doppleProduct.product.setValue('chairColor', 'quartz');
		doppleProduct.product.setValue('backPanel', 'ivoryOakV2');
		doppleProduct.product.setValue('fabric', 'steelBoucle');
	  } 
	 
	  $(".sticky_img").click(function(){    
		doppleProduct.product.setValue('runRotation', false);
	  });
	});